
import React from "react";
import { Button } from "@/components/ui/button";

interface ActionsCellProps {
  onClick: () => void;
}

const ActionsCell = ({ onClick }: ActionsCellProps) => {
  return (
    <Button 
      variant="secondary" 
      size="sm" 
      className="whitespace-nowrap h-auto min-h-9"
      onClick={onClick}
    >
      Details
    </Button>
  );
};

export default ActionsCell;
